import { render, staticRenderFns } from "./PersonShow.vue?vue&type=template&id=5699b0e8&scoped=true&"
import script from "./PersonShow.vue?vue&type=script&lang=js&"
export * from "./PersonShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5699b0e8",
  null
  
)

export default component.exports